import $ from "jquery";

const TABLET_RESOLUTION = 1019;

const isDesktop = () => {
    return window.outerWidth > TABLET_RESOLUTION
};

export const mobileMenuHeight = () => {
    const intViewportHeight = window.innerHeight;

    if (!isDesktop()) {
        $(".nav__wrap").css("height", intViewportHeight);
    }
};
